import { Component, inject } from '@angular/core';
import { BANK_ACCOUNT_FORM_NAME, CLIENT_FORM_NAME } from 'src/app/services/form/form.factory';
import { BankAccountForm } from 'src/app/services/form/form.controls';
import { FormService } from 'src/app/services/form/form.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { CompanySearchBankAccountItem } from 'src/app/shared/company-search-service/company-search.service';
import { PayeeCompanySearchBankAccountPickerComponent } from 'src/app/shared/payee-company-search-bank-account-picker/payee-company-search-bank-account-picker.component';
import * as ibantools from 'ibantools';

@Component({
  selector: 'app-bank-account-form',
  templateUrl: './bank-account-form.component.html',
  styleUrls: ['./bank-account-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    TranslateModule,
    PayeeCompanySearchBankAccountPickerComponent,
  ],
})
export class BankAccountFormComponent {
  private formService = inject(FormService);
  private clientsService = inject(ClientsService);

  get form(): BankAccountForm {
    return this.formService.form.controls[BANK_ACCOUNT_FORM_NAME]!;
  }

  get account_number() {
    return this.form.controls.account_number;
  }

  get clientTaxNumber(): string | null {
    return this.formService.form.controls[CLIENT_FORM_NAME]?.controls.tax_number.value
      ?? this.clientsService.selectedClientSubject.value?.tax_number
      ?? null;
  }

  selectedBankName = '';
  private selectedAccountNumber = '';

  get showBankName(): boolean {
    return !!this.selectedBankName
      && this.accountNumbersMatch(this.account_number.value, this.selectedAccountNumber);
  }

  applyCompanySearchAccount(account: CompanySearchBankAccountItem): void {
    const value = account.iban || account.account_number || '';
    this.selectedBankName = account.bank_name ?? '';
    this.selectedAccountNumber = value;
    if (!value || this.accountNumbersMatch(this.account_number.value, value)) {
      return;
    }

    this.account_number.setValue(value);
    this.account_number.markAsDirty();
    this.account_number.updateValueAndValidity({ emitEvent: true });
  }

  private accountNumbersMatch(
    left: string | null | undefined,
    right: string | null | undefined,
  ): boolean {
    return this.normalizeAccount(left) === this.normalizeAccount(right);
  }

  private normalizeAccount(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return ibantools.electronicFormatIBAN(value) || value.replace(/\s/g, '');
  }
}
